// extracted by mini-css-extract-plugin
export default {"container":"AvatarCircle_container__PL+0N","icon":"AvatarCircle_icon__4GK8I","avatar":"AvatarCircle_avatar__FwB0C","duel":"AvatarCircle_duel__PSgrs","ana":"AvatarCircle_ana__CAgA4"};